import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { InternshipListDataService } from 'common/services/data-services/admin/internship/internship-list.service';
import { API_URL } from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { InternshipListModel } from 'common/models/page-models/internship/internship-list/form-model/internship-list-form-data.model';
import { InternshipListGridMetaModel } from 'common/models/page-models/internship/internship-list/grid-model/internship-list-grid-meta-model';
import { InternshipListListingModel } from 'common/models/page-models/internship/internship-list/grid-model/internship-list-grid-model';
 
@Injectable({
    providedIn: 'root'
})
export class InternshipListWidgetService extends GridWidgetService<InternshipListModel, InternshipListListingModel> {
    constructor(protected override ds: InternshipListDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    getMetaModel(): MetaModel {
        const meta = new InternshipListGridMetaModel().getMetaModel();
        return meta;
    }

    override getUrlList(): any[] {
        const postObj = {
            typeOfStatus: 2,
            year: "2024"
        }
        const urlList = [
            { url: environment.apiUrl + API_URL.internshipList, payload: postObj },
            { url: environment.apiUrl + API_URL.InternshipStudentDashboardCounts, payload: postObj },
          ];
          return urlList;
    }
}